module.exports = __webpack_public_path__ + "static/media/cover_photo_2.cc372589.png";